import React from 'react'
import styled from 'styled-components'
import { motion } from 'framer-motion'
import { childVariants } from '../../../framerOptions'
import { useCongress } from '../../../congress/hooks'
import Layout from '../../../components/Layout'

export default function EventInformationCard () {
  const { congress } = useCongress()
  const plainBody = congress.LandingInformationBody?.replace(/<[^>]+>/g, '')
  if (plainBody) {
    return (
     <Container>
       {congress.LandingInformationTitle ? (
         <motion.div variants={childVariants}>
           <Layout.Title>{congress.LandingInformationTitle}</Layout.Title>
         </motion.div>
       ) : null}
       <CardContainer variants={childVariants}>
         <div dangerouslySetInnerHTML={{ __html: congress.LandingInformationBody }} />
       </CardContainer>
     </Container>
    )
  } else {
    return null
  }
}

const Container = styled.div`
  margin: 5rem 0;
`

const CardContainer = styled(motion.div)`
  display: inline-block;
  background: #FFF;
  box-shadow: 0 3px 20px rgba(197, 217, 232, 0.5);
  border-radius: 12px;
  width: 100%;
  margin: 1.2rem 0;
  padding: 2rem;
`
